export const normalizeAddressResponse = (data, maxNumber = 20) => {
  if (Array.isArray(data) && data.length > 0) {
    const newData = data
      .map((address) => {
        const label = address.address;
        const value = address.idGeographicSite;
        return { ...address, label, value };
      })
      .slice(0, maxNumber);
    return newData;
  }
  return null;
};
